import { gql } from '@apollo/client/core'
import Mail from 'globals/models/Mail'

export const MARK_MAILS_AS_DISPOSED = gql`
  mutation markUserMailsAsDisposed(
    $userMailIds: [ID!]!
  ) {
    markUserMailsAsDisposed(userMailIds: $userMailIds) {
      userMails {
        id
        mailType
        createdAt
        dateOfReceipt
        forwardedAt
        physicalLocation
        physicallyDestroyedAt
        processingType
        processingDate
        provisionedAt
        queryDate
        scanFile
        scannedAt
        sendName
        weight
      }
    }
  }
`

export interface MarkMailsAsDisposedVariables {
  userMailIds: number[]
}

export interface MarkMailsAsDisposedResult {
  markUserMailsAsDisposed: {
    userMails: Mail[]
  }
}
